import React, {Component} from 'react';
import {Menu} from 'antd';
import coSvg from "../../../../resources/img/co.svg";
import usSvg from "../../../../resources/img/us.svg";

class PublicHeaderMenu extends Component {

  handleLanguage = () => {
    this.props.changeLanguage(this.props.language);
  };

  render() {
    return (
      <Menu
        theme="light"
        mode={this.props.mode}
        defaultSelectedKeys={['/']}
        selectedKeys={[this.props.pathname.split('/')[1]]}
        style={{lineHeight: '32px'}}
      >
        <Menu.Item onClick={this.handleLanguage}>
          {this.props.language === 'es' ? <img style={{width: 30}} alt={'COL flag'} src={coSvg}/> : <img style={{width: 30}} alt={'US flag'} src={usSvg}/>}
        </Menu.Item>
      </Menu>
    );
  }
}

export default PublicHeaderMenu;
